import React, { useState, useCallback, useMemo } from 'react';
import TabContext from '@material-ui/lab/TabContext';
import { Tabs, Tab } from '@material-ui/core';
import TabPanel from '@material-ui/lab/TabPanel';
import SessionLineupsForm from './SessionLineupsForm';
import { TSession } from '../Sessions';
import { LineupReason } from '../../../services/sessionsUpload';
import { ClassType, PeriodType } from '../../../api';
import { Player } from '../../../services/references';
import { TLineupEntry } from './SessionLineupsPlayer';

interface Props {
  session?: TSession;
  lineup?: Array<TLineupEntry>;
  onChangeLineupEntry: (newEntry: TLineupEntry, prevEntry: TLineupEntry) => void;
  onDeleteSubstitution: (entry: TLineupEntry) => void;
  onDeleteRedCard: (entry: TLineupEntry) => void;
  onAddExit: (out: TLineupEntry, reason: LineupReason, outSeconds: number, period: PeriodType) => void;
  onAddSubstitution: (out: TLineupEntry, outSeconds: number, period: PeriodType, playerIn: Player) => void;
}

const SessionLineupsTabs: React.FunctionComponent<Props> = ({
  session,
  lineup,
  onChangeLineupEntry,
  onDeleteRedCard,
  onDeleteSubstitution,
  onAddExit,
  onAddSubstitution,
}) => {
  const [value, setValue] = useState('home');

  const handleChange = useCallback((event: React.ChangeEvent<{}>, newValue: string) => {
    setValue(newValue);
  }, []);

  const homeLineup = useMemo(() => {
    return lineup?.filter((l) => l.type === ClassType.HomeKeeper || l.type === ClassType.HomePlayer);
  }, [lineup]);

  const awayLineup = useMemo(() => {
    return lineup?.filter((l) => l.type === ClassType.AwayKeeper || l.type === ClassType.AwayPlayer);
  }, [lineup]);

  const allPlayers = useMemo(() => {
    return lineup?.filter((l) => l.player).map((l) => l.player?.id || '') || [];
  }, [lineup]);

  return (
    <div>
      <TabContext value={value}>
        <Tabs value={value} onChange={handleChange} aria-label="lineup">
          <Tab label={!session?.homeTeam?.name ? 'Home' : session?.homeTeam?.name} key="home" value="home" />
          <Tab label={!session?.awayTeam?.name ? 'Away' : session?.awayTeam?.name} key="away" value="away" />
        </Tabs>
        <TabPanel value="home">
          <SessionLineupsForm
            allPlayers={allPlayers}
            session={session}
            team={session?.homeTeam?.id}
            lineup={homeLineup}
            onChangeLineupEntry={onChangeLineupEntry}
            onDeleteRedCard={onDeleteRedCard}
            onDeleteSubstitution={onDeleteSubstitution}
            onAddExit={onAddExit}
            onAddSubstitution={onAddSubstitution}
          />
        </TabPanel>
        <TabPanel value="away">
          <SessionLineupsForm
            allPlayers={allPlayers}
            session={session}
            team={session?.awayTeam?.id}
            lineup={awayLineup}
            onChangeLineupEntry={onChangeLineupEntry}
            onDeleteRedCard={onDeleteRedCard}
            onDeleteSubstitution={onDeleteSubstitution}
            onAddExit={onAddExit}
            onAddSubstitution={onAddSubstitution}
          />
        </TabPanel>
      </TabContext>
    </div>
  );
};

export default SessionLineupsTabs;
